import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfilesTable } from '../../../common/profiles-list/ProfilesTable';

type CustomersTableProps = React.PropsWithChildren<{
  isEmpty: boolean;
}>;

export const CustomersTable: React.FC<CustomersTableProps> = ({ isEmpty, children }) => {
  const { t } = useTranslation();
  return (
    <ProfilesTable
      ariaLabel={t('customerProfiles.header')}
      isEmpty={isEmpty}
      emptyMessage={t('messages.emptyCustomersMessage')}
    >
      {children}
    </ProfilesTable>
  );
};
